import { useMap } from 'ms-map-gl'
import { useEffect } from 'react'
import { useDisplay as HexagonDisplay } from '~map-preview/states/hexagons'
import { useDisplay as BoundaryDisplay } from '~map-preview/states/boundaries'

export const useSetPitch = () => {
  const { default: map } = useMap()
  const hexagonDisplay = HexagonDisplay()
  const boundaryDisplay = BoundaryDisplay()

  useEffect(() => {
    if (!map) return

    map.easeTo({ pitch: 0, duration: 1000 })

    if (hexagonDisplay === '3D' || boundaryDisplay === '3D') {
      map.easeTo({ pitch: 60, duration: 1000 })
    } else {
      map.easeTo({ pitch: 0, bearing: 0, duration: 1000 })
    }
  }, [map, hexagonDisplay, boundaryDisplay])
}
